// extracted by mini-css-extract-plugin
export default {"white100Base":"#fff"};